import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonLoading,
  IonModal,
} from "@ionic/react";
import PatientExistModal from "../components/modals/patient-exist-modal";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import { useRecoilState } from "recoil";
import {
  PatientState,
  dropDownStateToSave,
  networkConnectionStatus,
  newAllDropDownState,
} from "../data/atoms";
import { ActionType } from "../models/Enums";
import { GetGeneralLookupData, GetPatientById } from "../services/AuthServices";
import TopLeftUserName from "../components/TopLeftUserName";
import { PatientVM } from "../models/PatientVM";
import { format } from "date-fns";
import { PatientFormDropdowns } from "../models/PatientFormDropdowns";
import {
  convertTo12HourFormat,
  formatDateToMMDDYYYY,
  utcToLocalDate,
} from "../utils/sharedFunction";

interface Props {
  props: any;
}

const PatientProfile: React.FC<Props> = ({ props }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState<PatientFormDropdowns>(dropDownStateToSave);
  const [patientInfo, setpatientInfo] = useRecoilState(PatientState);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [openSection, setOpenSection] = useState<"patient" | "medical">(
    "patient",
  );
  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);
  const [shown, setShown] = useState(false);
  const [patientNotExistModal, setPatientNotExistModal] = useState(false);

  const toggleSection = (section: "patient" | "medical") => {
    setOpenSection((prev) =>
      prev === section
        ? section === "patient"
          ? "medical"
          : "patient"
        : section,
    );
  };
  let location =
    window.location.href == window.location.origin + "/patient-profile"
      ? true
      : false;

  async function GetUser() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setShowLoading(true);
    try {
      await GetPatientById({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      })
        .then(async function (response) {
          if (
            response!.data.responseCode !== 0 &&
            Number(response?.data?.patientVM?.id) === -1
          ) {
            setPatientNotExistModal(true);
            return;
          }
          if (response!.data.responseCode !== 0) {
            // if (response?.data?.patientVM) {
            //   response.data.patientVM.rtmStartDate = utcToLocalDate(
            //     response.data.patientVM.rtmStartDate,
            //   );
            // }

            localStorage.setItem(
              "patientServerID",
              response?.data?.patientVM?.id,
            );

            setpatientInfo((prevState: PatientVM) => ({
              ...prevState,
              ...response!.data.patientVM,
              referralId: response!.data.patientVM.referralSourceId,
              followUpTypeId: response!.data.patientVM.followUpTypeId,
            }));

            setPatientDetails(response!.data.patientVM);

            localStorage.setItem(
              "fullName",
              patientDetails!.firstName + " " + patientDetails!.lastName,
            );

            history.push("/create-edit-patient", { props: true });
            return;
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }

    setShowLoading(false);
  }

  useEffect(() => {
    setPatientDetails(patientDetailsRecoil);
    initializeAllArrays();

    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;

    console.log(
      "isRtmConfigurationEnabled",
      localStorage.getItem("isRtmEnabled"),
    );

    return () => {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        ...newAllDropDownState,
      }));
    };
  }, [location]);

  async function initializeAllArrays() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    await GetGeneralLookupData({
      localDateTime: new Date(),
      returnReferrals: true,
      returnDepartment: true,
      returnPhysician: true,
      returnTags: true,
      returnDiagnosis: true,
      returnPatientSettings: true,
      clinicianRole: false,
      returnMedications: true,
      returnMobilities: false,
      returnFollowUpTypes: true,
    })
      .then(async function (response) {
        if (response!.data.responseCode === 1) {
          await getResponseSetupDropDown(response!.data);
        }
      })
      .catch((error) => {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      });
  }

  const getResponseSetupDropDown = (response: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setNewAllDropDown((prevState: PatientFormDropdowns) => ({
      ...prevState,
      settingOpt: response.patientsSettings,
      departmentOpt: response.departments.reverse(),
      physicianOpt: response.physicians.reverse(),
      referralOpt: response.referrals.reverse(),
      tagsOpt: response.tags.reverse(),
      diagnosisOpt: response.diagnosis,
      medicationsOpt: response.medications,
      followUpTypesOpt: response.followUpTypes,
      setting:
        patientDetailsRecoil?.patientSetting !== 6
          ? response.patientsSettings.find(
              (setting: any) =>
                setting.id == patientDetailsRecoil.patientSetting,
            )
          : newAllDropDown?.setting,
      tags: newAllDropDown?.tags?.length
        ? [
            ...newAllDropDown.tags.map((tag: any) => {
              return response?.tags?.find((patTag: any) => {
                if (tag?.id == patTag?.id) return { ...tag, name: patTag.name };
              });
            }),
          ]
        : patientDetailsRecoil?.tagIds !== null &&
            patientDetailsRecoil?.tagIds.length
          ? [
              ...response.tags.filter((tag: any) => {
                return patientDetailsRecoil?.tagIds.find((patTag: any) => {
                  if (tag.id == patTag) return tag;
                });
              }),
            ]
          : [],
      diagnosis: newAllDropDown?.diagnosis?.length
        ? [
            ...newAllDropDown.diagnosis.map((Diag: any) => {
              return response?.diagnosis?.find((DiagTag: any) => {
                if (Diag?.id == DiagTag?.id)
                  return { ...Diag, name: DiagTag.name };
              });
            }),
          ]
        : patientDetailsRecoil?.diagnosisIds !== null &&
            patientDetailsRecoil?.diagnosisIds.length
          ? [
              ...response.diagnosis.filter((diagnosis: any) => {
                return patientDetailsRecoil?.diagnosisIds.find(
                  (patDiagnosis: any) => {
                    if (diagnosis.id == patDiagnosis) return diagnosis;
                  },
                );
              }),
            ]
          : [],
      referral:
        patientDetailsRecoil?.referralId !== null &&
        patientDetailsRecoil?.referralId !== -1
          ? response.referrals.find(
              (referral: any) => referral.id == patientDetailsRecoil.referralId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
      physician:
        patientDetailsRecoil?.physicianId !== null &&
        patientDetailsRecoil?.physicianId !== -1
          ? response.physicians.find(
              (physician: any) =>
                physician?.id == patientDetailsRecoil.physicianId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
      department:
        patientDetailsRecoil?.departmentId !== null &&
        patientDetailsRecoil?.departmentId !== -1
          ? response.departments.find(
              (department: any) =>
                department.id == patientDetailsRecoil.departmentId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
      medications: newAllDropDown?.medications?.length
        ? [
            ...newAllDropDown?.medications?.map((medicine: any) => {
              return response?.medications?.find((DiagMedicine: any) => {
                if (medicine?.id == DiagMedicine?.id)
                  return { ...medicine, name: DiagMedicine.name };
              });
            }),
          ]
        : patientDetailsRecoil?.medicationIds !== null &&
            patientDetailsRecoil?.medicationIds.length
          ? [
              ...response.medications.filter((medicine: any) => {
                return patientDetailsRecoil?.medicationIds.find(
                  (patMedicine: any) => {
                    if (medicine.id == patMedicine) return medicine;
                  },
                );
              }),
            ]
          : [],
      followUpType:
        patientDetailsRecoil?.followUpTypeId !== null &&
        patientDetailsRecoil?.followUpTypeId !== -1
          ? response.followUpTypes.find(
              (followUpType: any) =>
                followUpType.id == patientDetailsRecoil.followUpTypeId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
    }));
  };

  //This method will check if the patientDetails object is empty or not (black screen issue Fix) //Added by Hasnat
  function isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }
  let history = useHistory();

  return (
    <IonPage placeholder={undefined}>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={"Please wait..."}
        duration={200}
      />

      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={patientNotExistModal}
        placeholder={undefined}
      >
        <PatientExistModal
          setShowModal1={setPatientNotExistModal}
          actionType={ActionType.PatientDoesNotExist}
        ></PatientExistModal>
      </IonModal>

      <TopLeftUserName
        headerText={"Patient Page"}
        getUser={GetUser}
      ></TopLeftUserName>

      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid
          className="container new-edit-user-page new-patient-page"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="heading-sec-wrap">
                <div className="heading-in-circle">
                  {patientDetails !== null &&
                    patientDetails !== undefined &&
                    !isEmpty(patientDetails) && (
                      <h1>
                        {patientDetails!.firstName[0].toUpperCase()}
                        {patientDetails!.lastName[0].toUpperCase()}
                      </h1>
                    )}
                </div>

                <div className="heading-in-circle-right-sec">
                  <h4>
                    {patientDetails?.firstName + " " + patientDetails?.lastName}
                  </h4>
                  <h5>
                    {format(new Date(patientDetails?.dob), "MM/dd/yyyy")},{" "}
                    {patientDetails?.age}
                  </h5>
                  {patientDetails.isTestPatient && <h6>Test Patient</h6>}
                </div>
              </div>

              {/* Patient Info Accordion */}
              <div className="accordian mb-32">
                <div
                  className="accordian-header-wrap first-child"
                  onClick={() => toggleSection("patient")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="accordian-header">Patient Info</div>
                  <span className="toggleIconOpen"></span>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform:
                        openSection === "patient"
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {openSection === "patient" && (
                  <div className="accordian-body">
                    <div className="new-user-data-list">
                      <ul>
                        <li>
                          <strong>Phone</strong>
                          <span>{patientDetails?.mobilePhone}</span>
                        </li>
                        <li>
                          <strong>Email</strong>
                          {patientDetails && (
                            <span>{patientDetails?.email}</span>
                          )}
                        </li>
                        <li>
                          <strong>Zip Code</strong>
                          {patientDetails && <span>{patientDetails?.zip}</span>}
                        </li>
                        <li>
                          <strong>Current Status</strong>
                          {patientDetails && (
                            <span>
                              {newAllDropDown?.followUpType?.id !== undefined
                                ? newAllDropDown?.followUpType?.name
                                : ""}
                            </span>
                          )}
                        </li>

                        {rtmEnabledRef.current && (
                          <li className="d-flex align-items-center justify-content-between">
                            <strong>Remote Therapeutic Monitoring</strong>
                            <div
                              className={`rtm-checkbox-wrap  ${
                                patientDetails.isPatientRTMEnabled
                                  ? "enabled"
                                  : "disabled"
                              }`}
                            >
                              {patientDetails.isPatientRTMEnabled
                                ? "Enabled"
                                : "Disabled"}
                            </div>
                          </li>
                        )}
                        {rtmEnabledRef.current &&
                          patientDetails.isPatientRTMEnabled && (
                            <>
                              <li className="boder-bottom-0 pb-0">
                                <strong className="fw-400">
                                  RTM Start Date
                                </strong>
                                <span>
                                  {" "}
                                  {formatDateToMMDDYYYY(
                                    patientDetails?.rtmStartDate ?? new Date(),
                                  ) ?? ""}
                                </span>
                              </li>
                              <li>
                                <strong className="fw-400">
                                  Preferred Daily Exercise Start Time
                                </strong>
                                <span>
                                  {/* { convertTo12HourFormat(
                                    patientDetails?.preferredDailyExerciseStartTime ??
                                      ""
                                )} */}
                                  {patientDetails?.preferredDailyExerciseStartTime &&
                                  patientDetails?.preferredDailyExerciseStartTime !==
                                    null &&
                                  patientDetails?.preferredDailyExerciseStartTime !==
                                    undefined &&
                                  patientDetails?.preferredDailyExerciseStartTime !==
                                    "" &&
                                  patientDetails?.preferredDailyExerciseStartTime !==
                                    "NA"
                                    ? convertTo12HourFormat(
                                        patientDetails?.preferredDailyExerciseStartTime,
                                      )
                                    : "NA"}
                                </span>
                              </li>
                            </>
                          )}
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              {/* Medical Info Accordion */}
              <div className="accordian">
                <div
                  className="accordian-header-wrap first-child"
                  onClick={() => toggleSection("medical")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="accordian-header">Medical Info</div>
                  <span className="toggleIconOpen"></span>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transform:
                        openSection === "medical"
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <path
                      d="M15 5.5L9 11.5L3 5.5"
                      stroke="#005A75"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {openSection === "medical" && (
                  <div className="accordian-body">
                    <div className="new-user-data-list">
                      <ul>
                        <li>
                          <strong>MRN</strong>
                          {patientDetails && (
                            <span className="d-flex align-items-center">
                              {!shown ? (
                                <span style={{ letterSpacing: "0.3em" }}>
                                  {"•".repeat(patientDetails?.mrn?.length || 0)}
                                </span>
                              ) : (
                                patientDetails?.mrn
                              )}{" "}
                              <div onClick={() => setShown(!shown)}>
                                {!shown ? (
                                  <svg
                                    className="eye-sec-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 20"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M2.91789 0.792893C3.30842 0.402369 3.94158 0.402369 4.33211 0.792893L21.3321 17.7929C21.7226 18.1834 21.7226 18.8166 21.3321 19.2071C20.9416 19.5976 20.3084 19.5976 19.9179 19.2071L16.8946 16.1838C15.4729 16.8815 13.8569 17.375 12.1251 17.375C8.84297 17.375 5.96108 15.6045 3.97394 13.9574C2.96619 13.1221 2.15313 12.2891 1.59164 11.6649C1.31031 11.3522 1.09061 11.0902 0.939649 10.9043C0.864133 10.8113 0.80571 10.7371 0.765271 10.6851C0.745048 10.6591 0.729312 10.6385 0.718175 10.6239L0.704926 10.6064L0.700912 10.6011L0.699562 10.5993C0.699562 10.5993 0.698651 10.598 1.50011 10L0.698912 9.4016L0.700005 9.40014L0.702178 9.39725L0.70897 9.38824L0.732245 9.35769C0.752032 9.33188 0.780329 9.29533 0.816852 9.24905C0.889878 9.15652 0.995908 9.02491 1.13267 8.86228C1.40596 8.5373 1.80333 8.08684 2.30665 7.57578C3.12381 6.74606 4.23597 5.74051 5.56436 4.85357L2.91789 2.20711C2.52737 1.81658 2.52737 1.18342 2.91789 0.792893ZM13.5118 12.801L15.3848 14.674C14.3447 15.1083 13.2479 15.375 12.1251 15.375C9.53923 15.375 7.10862 13.958 5.25027 12.4176C4.33528 11.6592 3.59233 10.8984 3.07852 10.3273C2.9723 10.2092 2.87614 10.0995 2.79054 10C3.02745 9.7245 3.34472 9.372 3.73161 8.97917C4.55927 8.13878 5.6866 7.13322 7.01015 6.29936L9.32407 8.61329C9.11681 9.03124 9 9.50238 9 10.0001C9 11.726 10.3991 13.1251 12.125 13.1251C12.6225 13.1251 13.0937 13.0083 13.5118 12.801ZM11.7829 11.0721L11.053 10.3422C11.1633 10.6884 11.4367 10.9618 11.7829 11.0721Z"
                                      fill="#802392"
                                    ></path>
                                    <path
                                      d="M0.698912 9.4016C0.434196 9.75636 0.433934 10.2433 0.698651 10.598L1.50011 10C0.698651 9.40195 0.698912 9.4016 0.698912 9.4016Z"
                                      fill="#802392"
                                    ></path>
                                    <path
                                      d="M12.1251 4.625C11.8109 4.625 11.4988 4.64586 11.1895 4.68543C10.6417 4.75551 10.1408 4.36822 10.0707 3.8204C10.0006 3.27258 10.3879 2.77167 10.9357 2.70159C11.3253 2.65175 11.7222 2.625 12.1251 2.625C15.4073 2.625 18.2891 4.39548 20.2763 6.0426C21.284 6.87792 22.0971 7.71095 22.6586 8.3351C22.9399 8.64783 23.1596 8.90982 23.3106 9.09574C23.3861 9.18875 23.4445 9.26286 23.485 9.31491C23.5052 9.34094 23.5209 9.36147 23.5321 9.37611L23.5453 9.39359L23.5493 9.39893L23.5507 9.40074C23.5507 9.40074 23.5516 9.40195 22.7501 10L23.5514 10.5983L23.5496 10.6007L23.5461 10.6054L23.5347 10.6204C23.5251 10.633 23.5117 10.6505 23.4945 10.6728C23.4601 10.7173 23.4104 10.7806 23.3462 10.8602C23.2178 11.0195 23.0311 11.2446 22.7914 11.5159C22.3128 12.0577 21.6191 12.7885 20.7543 13.5492C20.3396 13.9139 19.7077 13.8734 19.343 13.4587C18.9782 13.044 19.0187 12.4121 19.4334 12.0474C20.2217 11.354 20.8562 10.6858 21.2925 10.1918C21.352 10.1244 21.4078 10.0603 21.4597 10C21.3741 9.90046 21.2779 9.79078 21.1717 9.67271C20.6579 9.10155 19.915 8.34083 19 7.5824C17.1416 6.04202 14.711 4.625 12.1251 4.625Z"
                                      fill="#802392"
                                    ></path>
                                    <path
                                      d="M23.5514 10.5983C23.8161 10.2435 23.8163 9.75671 23.5516 9.40195L22.7501 10C23.5516 10.598 23.5514 10.5983 23.5514 10.5983Z"
                                      fill="#802392"
                                    ></path>
                                  </svg>
                                ) : (
                                  <svg
                                    className="eye-ist-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 22 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                                      stroke="#802392"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                                      stroke="#802392"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                  </svg>
                                )}
                              </div>
                            </span>
                          )}
                        </li>

                        <li>
                          <strong>Department</strong>
                          {patientDetails && (
                            <span>
                              {newAllDropDown?.department?.id !== undefined
                                ? newAllDropDown?.department?.name
                                : ""}
                            </span>
                          )}
                        </li>
                        <li>
                          <strong>Physician</strong>
                          {patientDetails && (
                            <span>
                              {newAllDropDown?.physician?.id !== undefined
                                ? newAllDropDown?.physician?.name
                                : ""}
                            </span>
                          )}
                        </li>

                        <li>
                          <strong>Referral</strong>
                          {patientDetails && (
                            <span>
                              {newAllDropDown?.referral?.id !== undefined
                                ? newAllDropDown?.referral?.name
                                : ""}
                            </span>
                          )}
                        </li>
                        <li>
                          <strong>Setting</strong>
                          {patientDetails && (
                            <span>
                              {newAllDropDown?.setting?.id !== undefined
                                ? newAllDropDown?.setting?.name
                                : ""}
                            </span>
                          )}
                        </li>

                        <li className="new-patient-data-list-text">
                          <strong>Medications</strong>
                          <div className="new-patient-data-list">
                            <ul>
                              {newAllDropDown.medications.length
                                ? newAllDropDown.medications.map((tag: any) => (
                                    <li key={tag.id}>
                                      <span>{tag.name}</span>
                                    </li>
                                  ))
                                : ""}
                            </ul>
                          </div>
                        </li>

                        <li className="new-patient-data-list-text">
                          <strong>Diagnosis</strong>
                          <div className="new-patient-data-list">
                            <ul>
                              {newAllDropDown.diagnosis.length
                                ? newAllDropDown.diagnosis.map((tag: any) => (
                                    <li key={tag.id}>
                                      <span>{tag.name}</span>
                                    </li>
                                  ))
                                : ""}
                            </ul>
                          </div>
                        </li>

                        <li className="new-patient-data-list-text">
                          <strong>Tags</strong>
                          <div className="new-patient-data-list">
                            <ul>
                              {newAllDropDown.tags.length
                                ? newAllDropDown.tags.map((tag: any) => (
                                    <li key={tag.id}>
                                      <span>{tag.name}</span>
                                    </li>
                                  ))
                                : ""}
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default PatientProfile;
